import type { AccountAction, AccountMenuProps } from 'shared-react/lumen';

export interface AccountMenuController {
  disableDemo: () => void;
  enableDemo: () => void;
  hotelOrMarket: { hasRebranding: boolean };
  isDemoMode: boolean;
  logout: () => void;
  openHelpCenter: () => void;
  redirectReferAFriend: () => void;
  redirectToAdmin: () => void;
  redirectToSubscription: () => void;
}

export default function createAccountMenu(
  controller: AccountMenuController,
): Omit<AccountMenuProps, 'kind'> {
  return {
    hasRebranding: controller.hotelOrMarket.hasRebranding,
    isDemoMode: controller.isDemoMode,
    onAccountAction: (action: AccountAction): void => {
      switch (action) {
        case 'help':
          controller.openHelpCenter();
          break;
        case 'logout':
          controller.logout();
          break;
        case 'refer-a-friend':
          controller.redirectReferAFriend();
          break;
        case 'admin':
          controller.redirectToAdmin();
          break;
        case 'admin-subscription':
          controller.redirectToSubscription();
          break;
        case 'toggle-demo':
          if (controller.isDemoMode) {
            controller.disableDemo();
          } else {
            controller.enableDemo();
          }
          break;
        case 'admin-market':
        case 'admin-user':
          break;
      }
    },
  };
}
